import styled from 'styled-components';

export const ButtonBoxes = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;